




















































import { ZakazkaKorekceTempl } from '@/modules/ciselnik/dilenske/zakazkaKorekceTempl';
import { editFactory } from '@/main/pages';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { editMutations } from './store/types';
import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		ZakazkaKorekceTemplSelect: ZakazkaKorekceTempl.components.Select,
	},
	computed: {
		strednaklOznFilter(): object {
			return { ProvozovnaId: this.ProvozovnaId, disabledProvozovna: true };
		},
		mutationsMappers(): Record<string, string> {
			return {
				kod: `${this.storeUri}/${editMutations.KOREKCE_KOD_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${editMutations.KOREKCE_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
	},
});
